<template>
    <TransitionGroup>
        <AppCard v-if="loading" v-for="i in items" :key="i" shadow="shadow-sm" class="mb-4 animate-pulse">
            <div class="flex items-center pb-2">
                <div class="w-[45px] aspect-square rounded-full flex items-center justify-center relative overflow-visible bg-muted mr-4">
                    <div class="text-white font-bold text-lg bg-muted"></div>
                    <span class="absolute -bottom-1 -right-1 border-2 border-white rounded-full w-5 h-5 flex items-center justify-center bg-muted">
                        <svg class="svg-inline--fa fa-check fa-xs text-white" aria-hidden="true" focusable="false" data-prefix="far" data-icon="check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                           <path class="" fill="currentColor" d="M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"></path>
                        </svg>
                    </span>
                </div>
                <div class="w-1/4">
                    <p class="font-bold text-lg bg-muted mb-2">&nbsp;</p>
                    <p class="bg-muted">&nbsp;</p>
                </div>
            </div>
            <div class="flex items-center mb-2 mt-2">
                <div class="flex space-x-2 mr-auto">
                    <div class="flex-1 w-5 text-center">
                        <p class="bg-muted">&nbsp;</p>
                    </div>
                    <div class="flex-1 w-5 text-center">
                        <p class="bg-muted">&nbsp;</p>
                    </div>
                    <div class="flex-1 w-5 text-center">
                        <p class="bg-muted">&nbsp;</p>
                    </div>
                    <div class="flex-1 w-5 text-center">
                        <p class="bg-muted">&nbsp;</p>
                    </div>
                    <div class="flex-1 w-5 text-center">
                        <p class="bg-muted">&nbsp;</p>
                    </div>
                </div>
                <p class="text-sm bg-muted w-28">&nbsp;</p>
            </div>
            <h3 class="font-bold bg-muted w-1/2 mb-2">&nbsp;</h3>
            <p class="text-dark mb-2 bg-muted w-full">&nbsp;</p>
            <p class="text-dark mb-2 bg-muted w-full">&nbsp;</p>
            <p class="mb-2 w-1/4 bg-muted">&nbsp;</p>
            <div class="bg-muted w-16">&nbsp;</div>
        </AppCard>
    </TransitionGroup>
</template>

<script>
import AppCard from "@/Components/AppCard";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    components: {
        AppCard,
        FontAwesomeIcon
    },
    name: "ReviewCardLoader",
    props:
    {
        loading: {
          type: Boolean,
          default: true
        },
        items: {
            type: Number,
            default: 1
        }
    }
}
</script>

<style scoped>

</style>
